<template>
    <div :id="ID_COMPONENTE" class="container-fluid pb-0">
        <div class="row">
            <!-- CATALOGO DE PAGINAS DE INICIO -->
            <div :class="(esParaPaginaWeb) ? 'form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1 deshabilitarSeccionCatalogos' : 'form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1'">
                <h6>Página donde se muestra&nbsp;&nbsp;
                    <i :class="[(filtrosBusqueda.activos.PAGINA_INICIO.activo) ? 'fas fa-check-square check-activacion-filtros' : 'far fa-square check-activacion-filtros']" 
                        @click="evtActivacionFiltro(filtrosBusqueda.activos.PAGINA_INICIO.llave)"></i>
                </h6>
                <C001PaginaInicio  
                    :class="[false ? 'border border-danger p-0 m-0': 'p-0 m-0']" 
                    v-on:valorParaElPadre="evtCambioPaginaInicio" 
                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                    :idDelInput="filtrosBusqueda.catalogoPaginasDeInicio.ID" 
                    :parametros="filtrosBusqueda.catalogoPaginasDeInicio.parametros" 
                    :valorDefinido="filtrosBusqueda.catalogoPaginasDeInicio.valorDefinido" 
                    :key="filtrosBusqueda.catalogoPaginasDeInicio.KEY + ID_COMPONENTE + filtrosBusqueda.catalogoPaginasDeInicio.contRender"></C001PaginaInicio>
            </div>
            <!-- CATALOGO PARA TIPOS DE POSICION DEL MENU -->
            <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1">
                <h6>Posición donde se muestra&nbsp;&nbsp;
                    <i :class="[(filtrosBusqueda.activos.POSICION.activo) ? 'fas fa-check-square check-activacion-filtros' : 'far fa-square check-activacion-filtros']" 
                        @click="evtActivacionFiltro(filtrosBusqueda.activos.POSICION.llave)"></i>
                </h6>
                <C005TiposPosicion  
                    :class="[false ? 'border border-danger p-0 m-0': 'p-0 m-0']" 
                    v-on:valorParaElPadre="evtCambioPosicion" 
                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                    :idDelInput="filtrosBusqueda.catalogoTiposPosiciones.ID" 
                    :parametros="filtrosBusqueda.catalogoTiposPosiciones.parametros" 
                    :valorDefinido="filtrosBusqueda.catalogoTiposPosiciones.valorDefinido" 
                    :key="filtrosBusqueda.catalogoTiposPosiciones.KEY + ID_COMPONENTE + filtrosBusqueda.catalogoTiposPosiciones.contRender"></C005TiposPosicion>
            </div>
            <!-- TITULO -->
            <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1">
                <h6>Título de Menú&nbsp;&nbsp;
                    <i :class="[(filtrosBusqueda.activos.TITULO.activo) ? 'fas fa-check-square check-activacion-filtros' : 'far fa-square check-activacion-filtros']"
                        @click="evtActivacionFiltro(filtrosBusqueda.activos.TITULO.llave)"></i>
                </h6>
                <input v-model="filtrosBusqueda.titulo" type="text" id="titulo_menu" class="form-control" placeholder="Ingrese el título del menú" />
            </div>
            <!-- CARACTERISTICAS DE MENU -->
            <div id="filtros-caracteristicas-mpw" class="form-group row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-3 no-gutters">
                <fieldset class="scheduler-border row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 pt-1 no-gutters">
                    <legend class="scheduler-border">Características de menú&nbsp;&nbsp;
                        <i :class="[(filtrosBusqueda.activos.CARACTERISTICAS.activo) ? 'fas fa-check-square check-activacion-filtros' : 'far fa-square check-activacion-filtros']"
                            @click="evtActivacionFiltro(filtrosBusqueda.activos.CARACTERISTICAS.llave)"></i>
                    </legend>
                    <!-- ES DESCARGA -->
                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pl-3">
                        <div class="form-inline">
                            <h6 class="pr-2"><i class="fas fa-file-download"></i>&nbsp;&nbsp;Es para descarga:&nbsp;</h6>
                            <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                <label :class="[filtrosBusqueda.esDescarga ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.esDescarga = true">
                                    <input type="radio" name="options" id="radioEsDescarga" autocomplete="off"  checked>Si
                                </label>
                                <label :class="[!filtrosBusqueda.esDescarga ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.esDescarga = false">
                                    <input type="radio" name="options" id="radioNoEsDescarga" autocomplete="off" >No
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- MENU ESPECIAL -->
                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pl-3">
                        <div class="form-inline">
                            <h6 class="pr-2"><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Es menú especial:&nbsp;</h6>
                            <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                <label :class="[filtrosBusqueda.esMenuEspecial ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.esMenuEspecial = true">
                                    <input type="radio" name="options" id="radioEsMenuEspecial" autocomplete="off"  checked>Si
                                </label>
                                <label :class="[!filtrosBusqueda.esMenuEspecial ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.esMenuEspecial = false">
                                    <input type="radio" name="options" id="radioEsMenuEspecial" autocomplete="off" >No
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- MENU PARPADEA -->
                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pl-3">
                        <div class="form-inline">
                            <h6 class="pr-2"><i class="fab fa-flickr"></i>&nbsp;&nbsp;Menú parpadea:&nbsp;</h6>
                            <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                <label :class="[filtrosBusqueda.menuParpadea ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.menuParpadea = true">
                                    <input type="radio" name="options" id="radioEsMenuParpadea" autocomplete="off"  checked>Si
                                </label>
                                <label :class="[!filtrosBusqueda.menuParpadea ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.menuParpadea = false">
                                    <input type="radio" name="options" id="radioEsMenuParpadea" autocomplete="off" >No
                                </label>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
            <!-- FIN CARACTERISTICAS DE MENU -->
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-1">
                <div class="d-flex justify-content-end">
                    <button type="button" @click="evtLimpiarFiltros" class="btn btn-primary"><i class="fas fa-redo-alt"></i>&nbsp;&nbsp;Limpiar</button>
                    <button v-if="habilitarBusqueda" type="button" @click="evtRealizarBusqueda" class="btn btn-primary ml-2"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import catalogos from '@/../static/js/catalogos'
import enumeraciones from '@/../static/js/enumeraciones'
export default {
     props: {
        ID_COMPONENTE: {
            type: String,
            default: 'filtrosDeBusqueda-menus-pw'
        },
        esParaPagina: {
            type: Object,
            default: () => ({ tipoPagina: 1 })
        },
    },
    components: {
        C005TiposPosicion: catalogos.SICPO.C005TiposPosicion,
        C001PaginaInicio: catalogos.SICPO.C001PaginaInicio
    },
    data() {
        return {
            enumeraciones,
            PAGINA_OFICIAL_ID: 1,
            filtrosBusqueda: {
                titulo: null,
                esDescarga: false,
                esMenuEspecial: false,
                menuParpadea: false,
                catalogoPaginasDeInicio: {
                    ID: 'CPaginaInicio',
                    REF: 'REFPaginaInicio',
                    parametros: { PaginaDeInicioId: null, TipoPaginaId: 1, PaginaWebId: null, PaginaMicrositioId: null, MenuId: null, ConInactivas: false, ConMenus: false, ConPaginasWeb: false, ConPaginasMicrositios: false },
                    valorDefinido: -1,
                    paginaSeleccionada: null,
                    KEY: 'KPaginaInicio',
                    contRender: 0
                },
                catalogoTiposPosiciones: {
                    ID: 'CTiposDePosicion',
                    REF: 'REFTiposDePosicion',
                    parametros: { TipoPosicionId: null, MenuId: null, ConInactivos: false, ConMenus: false },
                    valorDefinido: -1,
                    posicionSelccionada: null,
                    KEY: 'KTiposDePosicion',
                    contRender: 0
                },
                activos: {
                    PAGINA_INICIO: { activo: true, llave: 1 },
                    POSICION: { activo: true, lave: 2 }, 
                    TITULO: { activo: true, llave: 3 },
                    CARACTERISTICAS: { activo: true, llave: 4 }
                }
            }
        }
    },
    methods: {
        evtRealizarBusqueda: function() {
            const { titulo, catalogoPaginasDeInicio, catalogoTiposPosiciones, esDescarga, esMenuEspecial, menuParpadea, activos } = this.filtrosBusqueda;
            const FILTROS = {
                paginaId: (this.campoRequeridoEsValido(catalogoPaginasDeInicio.valorDefinido) && activos.PAGINA_INICIO.activo) ? catalogoPaginasDeInicio.valorDefinido : null,
                posicionId: (this.campoRequeridoEsValido(catalogoTiposPosiciones.valorDefinido) && activos.POSICION.activo) ? catalogoTiposPosiciones.valorDefinido : null,
                titulo: (this.campoRequeridoEsValido(titulo) && activos.TITULO.activo) ? titulo : null,
                esDescarga:(activos.CARACTERISTICAS.activo) ? esDescarga : false,
                esMenuEspecial: (activos.CARACTERISTICAS.activo) ? esMenuEspecial : false,
                menuParpadea: (activos.CARACTERISTICAS.activo) ? menuParpadea : false
            }
            this.$emit('RealizarBusquedaDeMenus', FILTROS);
        },
        evtLimpiarFiltros: function() {
            // catalogos
            this.filtrosBusqueda.catalogoPaginasDeInicio.parametros.TipoPaginaId = this.esParaPagina.tipoPagina;
            this.filtrosBusqueda.catalogoPaginasDeInicio.valorDefinido = this.PAGINA_OFICIAL_ID;
            this.filtrosBusqueda.catalogoTiposPosiciones.valorDefinido = -1;
            // caracteristicas
            this.filtrosBusqueda.titulo = null;
            this.filtrosBusqueda.esDescarga = false;
            this.filtrosBusqueda.esMenuEspecial = false;
            this.filtrosBusqueda.menuParpadea = false;
            // se renderizan los catalogos
            this.filtrosBusqueda.catalogoPaginasDeInicio.contRender ++;
            this.filtrosBusqueda.catalogoTiposPosiciones.contRender ++;
        },
        evtCambioPaginaInicio: function(evento) {
            this.filtrosBusqueda.catalogoPaginasDeInicio.valorDefinido = parseInt(evento.target.value);
        },
        evtCambioPosicion: function(evento) {
            this.filtrosBusqueda.catalogoTiposPosiciones.valorDefinido = parseInt(evento.target.value);
        },
        evtActivacionFiltro: function(tipoDeFiltro) { 
            const ESTADO_DE_FILTROS = Object.values(this.filtrosBusqueda.activos);
            let filtro = ESTADO_DE_FILTROS.find(fb => fb.llave == tipoDeFiltro);
            if(this.campoRequeridoEsValido(filtro)) {
                filtro.activo = !filtro.activo;
            }
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    computed: {
        habilitarBusqueda() {
            return (this.campoRequeridoEsValido(this.filtrosBusqueda.catalogoTiposPosiciones.valorDefinido) && this.filtrosBusqueda.activos.POSICION.activo);
        }
    },
    created() {
        if(this.esParaPagina.tipoPagina == this.PAGINA_OFICIAL_ID) {
            this.filtrosBusqueda.catalogoPaginasDeInicio.parametros.TipoPaginaId = this.esParaPagina.tipoPagina;
            this.filtrosBusqueda.catalogoPaginasDeInicio.valorDefinido = this.PAGINA_OFICIAL_ID;
            this.esParaPaginaWeb = true;
            this.$nextTick(() => {
                // se actualiza catalogo de menus
                this.filtrosBusqueda.catalogoPaginasDeInicio.contRender ++;
            });
        }
    },
}
</script>
<style scoped>
#filtros-caracteristicas-mpw fieldset.scheduler-border {
    border: 1px groove #ddd !important;
    padding: 0 1.4em 1.4em 1.4em !important;
    margin: 0 0 1.5em 0 !important;
    -webkit-box-shadow:  0px 0px 0px 0px #000;
            box-shadow:  0px 0px 0px 0px #000;
}

#filtros-caracteristicas-mpw legend.scheduler-border {
    font-size: 1.2em !important;
    font-weight: bold !important;
    text-align: left !important;
    width:auto;
    padding:0 10px;
    border-bottom:none;
}

.deshabilitarSeccionCatalogos {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}

.check-activacion-filtros {
    cursor: pointer;
}

.btn-secondary:not(:disabled):not(.disabled).active, 
.btn-secondary:not(:disabled):not(.disabled):active, .show > #opciones-toggle .btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}

.btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
}

.btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/Menus/CFiltrosDeBusquedaMenus.vue